/* eslint-disable import/prefer-default-export */
import actionTypes from './actionTypes';
import { fetchCompanyById, getCompanyCertifications, fetchCompanyDocuments } from '../apis';

// #region DETAIL & UPDATE COMPANY INFO
export const getCompanyDetail = (companyId, cb) => {
  return {
    isAsyncCall: true,
    baseType: actionTypes.GET_COMPANY_OVERVIEW,
    asyncCall: () => {
      return fetchCompanyById(companyId);
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};

export const updateCompanyInfo = (companyId, data, cb) => {
  return {
    isAsyncCall: true,
    baseType: actionTypes.GET_COMPANY_OVERVIEW,
    asyncCall: () => {
      return fetchCompanyById(companyId);
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};

// #endregion
export const getCompanyCertificates = (companyId, params, cb) => {
  return {
    isAsyncCall: true,
    baseType: actionTypes.GET_COMPANY_CERTIFICATIONS,
    asyncCall: () => {
      return getCompanyCertifications(companyId, params);
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};

export const getCompanyDocuments = (companyId, params, cb) => {
  return {
    isAsyncCall: true,
    baseType: actionTypes.GET_COMPANY_DOCUMENTATIONS,
    asyncCall: () => {
      return fetchCompanyDocuments(companyId, params);
    },
    afterSuccessCall: (_dispatch, response) => {
      if (cb) cb(response);
    },
    afterFailureCall: (_dispatch, err) => {
      if (cb) cb(false, err);
    },
  };
};

export const updateParamCertification = (pagination, sorter) => {
  return {
    type: actionTypes.CHANGE_PARAMS_CERTIFICATIONS,
    payload: { pagination, sorter },
  };
};

export const updateParamDocument = (pagination, sorter) => {
  return {
    type: actionTypes.CHANGE_PARAMS_DOCUMENTATION,
    payload: { pagination, sorter },
  };
};
